module.exports = __webpack_public_path__ + "img/5c79529.webp";